import { render, staticRenderFns } from "./picmanagetable.vue?vue&type=template&id=5be64db7&scoped=true&"
import script from "./picmanagetable.vue?vue&type=script&lang=js&"
export * from "./picmanagetable.vue?vue&type=script&lang=js&"
import style0 from "./picmanagetable.vue?vue&type=style&index=0&id=5be64db7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5be64db7",
  null
  
)

export default component.exports